export const expandNavigationPaneButton = "_oiaY";
export default {expandNavigationPaneButton};